<template>
  <div class="domain">
    <div class="domain-item">
      <div class="domain-item__status-icon">
        <i class="el-icon-circle-check-outline" v-if="domain.active"></i>
        <i class="el-icon-circle-close-outline" v-if="!domain.active"></i>
      </div>
      <div class="domain-item__info">
        <div class="domain-item__info--first-row">
          <h3 class="domain-item__name">{{ domain.name }}</h3>
          <p class="badge-status badge-success" v-if="domain.active">
            Active
            <span>(since {{ domain.activated }})</span>
            </p>
          <p class="badge-status badge-danger" v-if="!domain.active">Disabled</p>
        </div>
        <p class="domain-item__path">{{ domain.path }}</p>
        <el-menu class="domain-item__dropdown" mode="horizontal">
          <el-submenu index="0" popper-class="domain-item__dropdown--items">
            <template slot="title">
              <i class="el-icon-more"></i>
            </template>
            <el-menu-item index="1">Change owner</el-menu-item>
            <el-menu-item index="2">Transfer</el-menu-item>
            <el-menu-item index="3">Disable</el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
    </div>
    <div class="subdomains" v-if="domain.subdomains.length > 0">
      <div
        class="subdomains__item"
        v-bind:key="subdomain.index"
        v-for="subdomain in domain.subdomains"
      >
        <div class="subdomains__item--space"></div>
        <div class="subdomains__item--info">
          <p class="subdomains_item--info--icon">
            <i class="el-icon-circle-check-outline" v-if="subdomain.valid"></i>
            <i class="el-icon-circle-close-outline" v-if="!subdomain.valid"></i>
          </p>
          <p class="subdomains__item--info--name">
            {{ subdomain.name }}.<span>{{ domain.name }}</span>
          </p>
          <p class="subdomains__item--info--path">{{ subdomain.path }}</p>
        </div>
        <div class="subdomains__item--status">
          <p class="subdomains__item--status--valid" v-if="subdomain.valid">Configured</p>
          <p class="subdomains__item--status--invalid" v-if="!subdomain.valid">
            <span>Error:</span> {{ subdomain.comment }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['domain'],
  data: () => ({}),
};
</script>
<style lang="scss">
.domain {
  margin-bottom: 0;
  padding: 25px;
  transition: background-color .3s ease;

  &:hover {
    background-color: #FFFFFF;
  }

  .subdomains {
    margin-top: 10px;

    &__item {
      display: flex;
      justify-content: stretch;
      font-size: 14px;

      &--space {
        flex: 1;
      }

      &--info {
        flex: 7;
        display: flex;
        justify-content: flex-start;

        p {
          margin: 10px 10px 10px 0;
        }

        &--name {
          font-weight: 700;

          span {
            font-weight: 300;
          }
        }

        &--path {
          font-weight: 300;
          font-style: italic;
        }
      }

      &--status {
        flex: 11;
        text-align: left;

        p {
          margin: 10px 0;
        }

        &--valid {
          color: #00D457;
        }

        &--invalid {
          span {
            color: #FF5960;
          }
        }
      }
    }
  }

  .domain-item {
    width: inherit;
    display: flex;

    .badge-status {
      width: 300px;
      flex: 2;
      font-weight: 700;
      font-size: 16px;
      margin-top: 0;
      margin-bottom: 3px;
      margin-left: 25px;

      span {
        color: #2c3e50;
        font-weight: 300;
      }
    }

    .badge-success {
      color: #00D457;
    }

    .badge-danger {
      color: #FF5960;
    }

    .el-menu-popup {
      min-width: 100px;
    }

    i {
      font-size: 30px;
      margin-right: 30px;
      position: relative;
      top: -1px;
    }

    i.el-icon-more {
      font-size: 20px;
    }

    &__info {
      width: 100%;

      &--first-row {
        display: flex;
        align-items: stretch;
        width: inherit;
      }
    }

    p {
      text-align: left;
      position: relative;
    }

    &__name {
      text-align: left;
      font-size: 20px;
      margin-top: 0;
      margin-bottom: 5px;
      flex: 1;
    }

    &__path {
      font-size: 16px;
      font-weight: 300;
      font-style: italic;
      margin-top: 5px;
      margin-bottom: 0;
    }

    &__dropdown {
      position: absolute;
      top: 0;
      right: 0;
      border: none;
      background-color: transparent;

      &--items {
        width: 150px;
      }

      .el-submenu {
        &.is-opened {
          position: relative;
          z-index: 20;
        }

        &__icon-arrow {
          display: none;
        }

        .el-icon-more {
          position: absolute;
          right: 20px;
          top: 26px;
          margin-right: 5px;
          font-size: 18px;
        }

        &__title,
        &__title:hover {
          background-color: transparent !important;
        }
      }

      .is-opened {
        z-index: 10;
      }
    }

    &__subdomain-container {
      width: 100%;
      height: 10px;
      background-color: red;
    }
  }

  .el-icon-circle-check-outline {
    color: #00D457;
  }

  .el-icon-circle-close-outline {
    color: #FF5960;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DomainItem.vue